/* ═══════════════════════════════════════
   Ocean Savage — Mobile Nav
   ═══════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (!toggle || !mobileNav) return;

  toggle.addEventListener('click', () => {
    toggle.classList.toggle('is-active');
    mobileNav.classList.toggle('is-open');
    const isOpen = mobileNav.classList.contains('is-open');
    document.body.classList.toggle('is-nav-open', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  // Close on link click
  mobileNav.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      toggle.classList.remove('is-active');
      mobileNav.classList.remove('is-open');
      document.body.classList.remove('is-nav-open');
      document.body.style.overflow = '';
    });
  });

  // Collections dropdown — desktop
  document.querySelectorAll('.nav-dropdown__trigger').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      btn.closest('.nav-dropdown').classList.toggle('is-open');
    });
  });

  // Collections dropdown — mobile
  document.querySelectorAll('.mobile-nav__dropdown-trigger').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      btn.closest('.mobile-nav__dropdown').classList.toggle('is-open');
    });
  });

  // Close desktop dropdown when clicking outside
  document.addEventListener('click', () => {
    document.querySelectorAll('.nav-dropdown.is-open').forEach(d => d.classList.remove('is-open'));
  });
});
